// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2945386","952":"a6b65e97"}[chunkId] + ".chunk.js";
};